import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { SessionManagerStateType } from '@central-products/interface-session-manager';
import { RETRYABLE_DELAY_INITIAL_TIME } from './constants';
import { abortable } from '../libs/abortable';
import { retryable, RetryableAbortedError } from '../libs/retryable';
import { SessionFoundError } from '../libs/session-found-error';
export var SessionLoginListenerPollingStrategy = /*#__PURE__*/function () {
  function SessionLoginListenerPollingStrategy(config) {
    _classCallCheck(this, SessionLoginListenerPollingStrategy);

    this.config = config;

    _defineProperty(this, "abortController", void 0);
  }

  _createClass(SessionLoginListenerPollingStrategy, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.abortController = new AbortController();
                _context.next = 4;
                return _Promise.race([this.watchAbort(), this.watchLogin()]);

              case 4:
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                this.stop();

                if (_context.t0 instanceof SessionFoundError) {
                  this.config.onStateChangedCallback(SessionManagerStateType.LOGGED_IN, _context.t0.state);
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.abortController) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (!this.abortController.signal.aborted) {
                  this.abortController.abort();
                  this.abortController = undefined;
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "watchAbort",
    value: function watchAbort() {
      var _this = this;

      return new _Promise(function (_, reject) {
        var onAbortCallback = function onAbortCallback() {
          _this.abortController.signal.removeEventListener('abort', onAbortCallback);

          reject();
        };

        _this.abortController.signal.addEventListener('abort', onAbortCallback);
      });
    }
  }, {
    key: "watchLogin",
    value: function watchLogin() {
      var _this2 = this;

      return retryable( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!_this2.abortController.signal.aborted) {
                  _context5.next = 2;
                  break;
                }

                throw new RetryableAbortedError();

              case 2:
                _context5.next = 4;
                return abortable( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  var responseCASSynchronization;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return _this2.config.casClient.init({
                            serviceUrl: _this2.config.serviceUrl,
                            custLogin: true
                          });

                        case 2:
                          responseCASSynchronization = _context3.sent;

                          if (responseCASSynchronization.success) {
                            _context3.next = 5;
                            break;
                          }

                          throw responseCASSynchronization;

                        case 5:
                          return _context3.abrupt("return", responseCASSynchronization);

                        case 6:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })), {
                  signal: _this2.abortController.signal
                });

              case 4:
                _context5.next = 6;
                return abortable( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                  var responseCASImAlive;
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.next = 2;
                          return _this2.config.casClient.imAlive();

                        case 2:
                          responseCASImAlive = _context4.sent;

                          if (responseCASImAlive.success) {
                            _context4.next = 5;
                            break;
                          }

                          throw responseCASImAlive;

                        case 5:
                          return _context4.abrupt("return", responseCASImAlive);

                        case 6:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                })), {
                  signal: _this2.abortController.signal
                });

              case 6:
                response = _context5.sent;
                throw new SessionFoundError(response.state);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      })), {
        delay: {
          initialTime: RETRYABLE_DELAY_INITIAL_TIME,
          maxTime: Infinity,
          exponentialBackoff: false,
          skipFirstDelay: false,
          jitter: false
        },
        retry: {
          predicate: function predicate(error) {
            if (error instanceof SessionFoundError) {
              /**
               * In case of `SessionExistsError` error we need to break
               * and do not try to retry anymore as there is CAS session found.
               */
              return false;
            }

            if (error instanceof DOMException && error.name === 'AbortError') {
              return false;
            }

            return !(error instanceof RetryableAbortedError);
          }
        }
      });
    }
  }]);

  return SessionLoginListenerPollingStrategy;
}();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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